// extracted by mini-css-extract-plugin
export default {"main":"MainBlock_main__RRMtC","main_wrap":"MainBlock_main_wrap__reL1I","main_title":"MainBlock_main_title__xfiBC","main_desc":"MainBlock_main_desc__ziAOw"};